import { secureFetch } from './auth'
import { HttpError, failureMessage } from './orders-api'

// R503 (b): the ring's two reads, both GETs; the ring never writes. Their shapes are R503 (a)'s
// Section 0: GET /admin/settings (every staff role, viewer included) and GET
// /admin/orders/waiting (hop, admin, kitchen, pos, viewer; owner and architect by rank).

export const RING_REASONS = ['pending', 'held_card', 'kitchen_not_started', 'final_check_not_started'] as const
export type RingReason = (typeof RING_REASONS)[number]

export interface WaitingReason {
  reason: string
  ageSeconds: number
}

export interface WaitingOrder {
  id: string
  shortCode: string | null
  status: string
  reasons: WaitingReason[]
  // Dee via Rook #67688: an order is named by the person and the plate. R503 (a)'s answer does not
  // carry these two; the follow-on server bench (THE-RING-NAMES-THE-PERSON-AND-THE-PLATE a2) adds
  // them, the items as the Cockpit card's name pairs (R482 (a)), 0 to 2 of them.
  customerName?: string | null
  items?: WaitingItem[] | null
}

export interface WaitingItem {
  nameEn: string | null
  nameAr: string | null
}

export interface WaitingAnswer {
  asOf: string
  orders: WaitingOrder[]
}

export interface SettingItem {
  key: string
  type: string
  value: unknown
  default: unknown
  bounds: unknown
  source: string
  updatedAt: string | null
}

export interface SettingsAnswer {
  entityId: string
  settings: SettingItem[]
}

export async function fetchRingSettings(): Promise<SettingsAnswer> {
  const res = await secureFetch('/api/admin/settings')
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<SettingsAnswer>
}

export async function fetchWaitingOrders(): Promise<WaitingAnswer> {
  const res = await secureFetch('/api/admin/orders/waiting')
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<WaitingAnswer>
}
